import * as THREE from "three";
import { patchArray, decorateArray } from "../../utils/data-utils";

import globalModels from "../global-models";
import seriesModels from "./models.json";

import globalEntities from "../global-entities";
import seriesEntities from "./entities.json";

import globalMaterials from "../global-materials";
import seriesMaterials from "./materials";

import globalTextures from "../global-textures";
import seriesTextures from "./textures.json";

import spots from "./spots";
import { createTimeAnimation, createToggleAnimation } from "../../utils/entity-utils";

let models = [];
let entities = [
  {
    id: "EnviroDome",
    object3D: "EnviroDome",
    parent: "scene",
    transform: {
      position: [1, -0.834946, 0],
      rotation: [-Math.PI / 2, 0, Math.PI],
    },
  },
  createTimeAnimation("Valtra_A_Frontloader", "Frontloader_Action", "{context.tractor.state.loaderPosition}"),
  createTimeAnimation("Valtra_A_SteeringWheel", "SteeringWheel_Action", "{context.tractor.state.steeringAngle}"),
  createTimeAnimation("Valtra_A_Steering", "Steering_Action", "{context.tractor.state.steeringAngle}"),

  createToggleAnimation("Valtra_A_Doors", "Doors_Action", "{context.tractor.state.doorOpen}"),
  createToggleAnimation("Valtra_A_Sunvisor", "Sunvisor_Action", "{context.tractor.state.Sunvisor}",{ action: { timeScale: 0.5 }}),

  createToggleAnimation("Valtra_A_0_VALTRA_FLAT_CAB", "Stair_Drop_Action", "{context.tractor.state.StrairsDown}"),

  createToggleAnimation("Valtra_A_FrontLinkage", "FrontLinkageWorkDrive_Action", "{context.tractor.state.frontLinkageWorkDrive}"),
  createToggleAnimation("Valtra_A_FrontLinkage", "FrontLinkageUp_Action", "{context.tractor.state.frontLinkage_up}"),
  

  ...spots,
];
let materials = [];
let textures = [];

models = patchArray(patchArray(globalModels, seriesModels), models);
entities = patchArray(patchArray(globalEntities, seriesEntities), entities);
materials = patchArray(globalMaterials, seriesMaterials, materials);
textures = patchArray(patchArray(globalTextures, seriesTextures), textures);

models = decorateArray(models, { preload: true });
textures = decorateArray(textures, {
  preload: true,
  encoding: THREE.sRGBEncoding,
});

const data = {
  entities,
  models,
  materials,
  textures,
};

process.env.NODE_ENV === "development" && console.log("a-series three", data);

export default data;
